

















import { Component, Vue } from "vue-property-decorator";
import DatePicker from "vuejs-datepicker";
import { card } from "@/board";
import { Action, State } from "vuex-class";
import moment from "moment";

@Component({
  components: {
    DatePicker
  }
})
export default class Calendar extends Vue {
  @Action getCardsByUser;
  @State("userCards") storeUserCards: card[];
  private currentDate = new Date();

  get userCards() {
    if (this.storeUserCards.length > 0) {
      return this.storeUserCards.filter(c => {
        const storeDate = new Date(c.dueOn);
        return (
          this.currentDate.getDay() === storeDate.getDay() &&
          this.currentDate.getMonth() === storeDate.getMonth() &&
          this.currentDate.getFullYear() === storeDate.getFullYear()
        );
      });
    }
    return this.storeUserCards;
  }

  get cardDate() {
    if (this.currentDate) {
      const formattedDate = moment(this.currentDate).format("MMM DD, YYYY");
      return formattedDate;
    }
    return "";
  }

  mounted() {
    this.getCardsByUser();
  }
}
